/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";

import { fetchPermissions } from "../redux/slices/branch/permissionManagerSlice";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";

import "../assets/css/dashboard.css";

import {
  FaUserFriends,
  FaMoneyCheckAlt,
  FaSearch,
  FaClipboardList,
  FaFileInvoice,
  FaPlus,
} from "react-icons/fa";
import { toast } from "react-toastify";

export default function BranchDashboard() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);

  const storedUserId = localStorage.getItem("userId");
  const userId = storedUserId ? Number(storedUserId) : null;

  const [collectionData, setCollectionData] = useState({});
  const [pendingCollectionData, setPendingCollectionData] = useState({});
  const [disbursementData, setDisbursementData] = useState({});
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [totalDashboardData, setTotalDashboardData] = useState({});
const [openingBalance, setOpeningBalance] = useState({ cashBalance: 0, totalBalance: 0 });
  const [closingBalance, setClosingBalance] = useState(0);
  const [groupLoanStats, setGroupLoanStats] = useState({});
  const [groupLoanDashboardData, setGroupLoanDashboardData] = useState({
    collection: { today: 0, weekly: 0, monthly: 0, yearly: 0, total: 0 },
    pendingCollection: { today: 0, weekly: 0, monthly: 0, yearly: 0, total: 0 },
    disbursement: { today: 0, weekly: 0, monthly: 0, yearly: 0, total: 0 },
    pendingDisbursement: {
      today: 0,
      weekly: 0,
      monthly: 0,
      yearly: 0,
      total: 0,
    },
  });

  const [activeTab, setActiveTab] = useState("loan");

  const formatINR = (value = 0) =>
    `₹ ${Number(value || 0).toLocaleString("en-IN")}`;

  /* ---------------- LOAD PROFILE & PERMISSIONS ---------------- */
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (userId) dispatch(fetchPermissions(userId));
  }, [dispatch, userId]);

  // Fetch Company
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`,
        );
        const data = await res.json();
        if (res.ok) {
          if (data.logo)
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              "",
            )}`;
          setCompany(data);
        }
      } catch (error) {
        console.log("Company fetching error:", error);
      }
    };

    fetchCompany();
  }, [profile]);

const fetchOpeningBalance = async () => {
    try {
      const res = await axios.get(`https://payyug.in/api/list/branch-wallet-master`, {
        params: {
          superAdminId: profile?.superAdminId,
          branchId: profile?.branchId || profile?.id,
        },
      });
      const data=res?.data?.data[0]||[];
      console.log("cash balance",data)
      setOpeningBalance({ cashBalance: data?.cashBalance, totalBalance: data?.totalBalance });
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          `Error Fetch Data: ${error}`
      );
    }
  };

  const fetchClosingBalance = async () => {
    try {
      const currentDateFormatted = new Date().toISOString().split("T")[0];

      const res = await axios.get(`https://payyug.in/api/report/day-book`, {
        params: {
          superAdminId: profile?.superAdminId,
          branchId: profile?.branchId || profile?.id,
          date: currentDateFormatted,
        },
      });
      const data = res?.data||res?.data?.data;
      // const netClosing = (Number(data?.totalCredit) || 0) + (Number(data?.totalDebit) || 0);
      setClosingBalance(data?.totalDebit);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          `Error Fetch Data: ${error}`
      );
    }
  };

  useEffect(() => {
    if (profile?.superAdminId && (profile?.branchId || profile?.id)) {
      fetchClosingBalance();
      fetchOpeningBalance();
    }
  }, [profile?.superAdminId, profile?.branchId, profile?.id]);

  /* ---------------- COLLECTION ---------------- */
  const fetchCollection = async () => {
    const res = await axios.get(
      "https://payyug.in/api/dashboard-collection/api",
      {
        params: {
          superAdminId: profile.superAdminId,
          branchId: profile.id,
        },
      },
    );
    setCollectionData(res.data?.data || {});
  };

  /* ---------------- PENDING COLLECTION ---------------- */
  const fetchPendingCollection = async () => {
    const res = await axios.get("https://payyug.in/api/dashboard-list/", {
      params: {
        superAdminId: profile.superAdminId,
        branchId: profile.id,
      },
    });
    setPendingCollectionData(res.data?.data || {});
  };

  /* ---------------- DISBURSEMENT (FIXED LOGIC) ---------------- */
  const fetchDisbursement = async () => {
    const filters = ["today", "week", "month", "year"];

    let disbursedTemp = {};
    let pendingTemp = {};

    let disbursedTotal = 0;
    let pendingTotal = 0;

    for (let f of filters) {
      const res = await axios.get(
        "https://payyug.in/api/dashbaord/loan-summery/disbursment",
        {
          params: {
            superAdminId: profile.superAdminId,
            filter: f,
          },
        },
      );

      const disbursedAmount = res.data?.data?.disbursed?.amount || 0;
      const pendingAmount = res.data?.data?.pendingDisbursement?.amount || 0;

      disbursedTemp[f] = disbursedAmount;
      pendingTemp[f] = pendingAmount;

      disbursedTotal += disbursedAmount;
      pendingTotal += pendingAmount;
    }

    setDisbursementData({
      disbursed: {
        today: disbursedTemp.today,
        weekly: disbursedTemp.week,
        monthly: disbursedTemp.month,
        yearly: disbursedTemp.year,
        total: disbursedTotal,
      },
      pending: {
        today: pendingTemp.today,
        weekly: pendingTemp.week,
        monthly: pendingTemp.month,
        yearly: pendingTemp.year,
        total: pendingTotal,
      },
    });
  };

  const fetchDashboardTotal = async () => {
    if (!profile?.superAdminId) return;
    try {
      const res = await axios.get(
        `https://payyug.in/api/all-dashboard/customer/branch?branchId=${profile.id}`,
      );
      if (res) {
        setTotalDashboardData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGroupLoanStats = async () => {
    if (!profile?.superAdminId) return;
    try {
      const res = await axios.get(
        `https://payyug.in/api/group-loan/disbursal-dashboard?superAdminId=${profile?.superAdminId}&createdBy=${profile?.id}`,
      );
      setGroupLoanStats(res.data?.dashboard);
      const data = res?.data?.dashboard;
      setGroupLoanDashboardData({
        collection: {
          today: data.collection?.today ?? 0,
          weekly: data.collection?.weekly ?? 0,
          monthly: data.collection?.monthly ?? 0,
          yearly: data.collection?.yearly ?? 0,
          total: data.collection?.total ?? 0,
        },
        pendingCollection: {
          today: data.pendingCollection?.today ?? 0,
          weekly: data.pendingCollection?.weekly ?? 0,
          monthly: data.pendingCollection?.monthly ?? 0,
          yearly: data.pendingCollection?.yearly ?? 0,
          total: data.pendingCollection?.total ?? 0,
        },
        disbursement: {
          today: data.disbursement?.today ?? 0,
          weekly: data.disbursement?.weekly ?? 0,
          monthly: data.disbursement?.monthly ?? 0,
          yearly: data.disbursement?.yearly ?? 0,
          total: data.disbursement?.total ?? 0,
        },
        pendingDisbursement: {
          today: data.pendingDisbursement?.today ?? 0,
          weekly: data.pendingDisbursement?.weekly ?? 0,
          monthly: data.pendingDisbursement?.monthly ?? 0,
          yearly: data.pendingDisbursement?.yearly ?? 0,
          total: data.pendingDisbursement?.total ?? 0,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  /* ---------------- LOAD DASHBOARD ---------------- */
  useEffect(() => {
    if (!profile?.superAdminId || !profile?.id) return;

    setLoading(true);
    Promise.all([
      fetchCollection(),
      fetchPendingCollection(),
      fetchDisbursement(),
      fetchDashboardTotal(),
      fetchGroupLoanStats(),
    ]).finally(() => setLoading(false));
  }, [profile]);

  if (loading) return <p className="loading-text">Loading dashboard...</p>;

  /* ---------------- UI DATA ---------------- */
  const kpiData = [
    {
      label: "Total Customers",
      value: totalDashboardData?.data?.totalCustomers ?? 0,
      color: "#2aa9b8",
      icon: <FaUserFriends />,
    },
    {
      label: "Total Active Loans",
      value: totalDashboardData?.data?.loans?.active ?? 0,
      color: "#d9c39a",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total Active Group Loans",
      value: groupLoanStats?.accounts?.active ?? 0,
      color: "#d9c39a",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total Pending Group Loans",
      value: groupLoanStats?.accounts?.pending ?? 0,
      color: "#d9c39a",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total Saving Account",
      value: totalDashboardData?.data?.totalSavingAccounts ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total FD Account",
      value: totalDashboardData?.data?.fdMisAccounts?.fd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total MIS Account",
      value: totalDashboardData?.data?.fdMisAccounts?.mis ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total RD Account",
      value: totalDashboardData?.data?.depositAccounts?.rd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
    {
      label: "Total DD(Pigmy) Account",
      value: totalDashboardData?.data?.depositAccounts?.dd ?? 0,
      color: "#933811",
      icon: <FaMoneyCheckAlt />,
    },
  ];

  const quickAccess = [
    {
      label: "Create Customer",
      icon: <FaPlus />,
      link: "/Customers/add",
    },
    {
      label: "Search Customer",
      icon: <FaSearch />,
      link: "/Customers/SearchCustomer",
    },
    {
      label: "Customer Reports",
      icon: <FaFileInvoice />,
      link: "/CustomerReport",
    },
    {
      label: "Loan Apply",
      icon: <FaClipboardList />,
      link: "/Loan/PersonalLoanForm",
    },
    {
      label: "Loan Reports",
      icon: <FaFileInvoice />,
      link: "/Loan/LoanReport",
    },
  ];

  const overviewData = [
    {
      title: activeTab === "loan" ? "Loan Collection" : "Group Loan Collection",
      stats: {
        TODAY: formatINR(
          activeTab === "loan"
            ? collectionData.today
            : groupLoanDashboardData?.collection?.today,
        ),
        WEEKLY: formatINR(
          activeTab === "loan"
            ? collectionData.weekly
            : groupLoanDashboardData?.collection?.weekly,
        ),
        MONTHLY: formatINR(
          activeTab === "loan"
            ? collectionData.monthly
            : groupLoanDashboardData?.collection?.monthly,
        ),
        YEARLY: formatINR(
          activeTab === "loan"
            ? collectionData.yearly
            : groupLoanDashboardData?.collection?.yearly,
        ),
        TOTAL: formatINR(
          activeTab === "loan"
            ? collectionData.total
            : groupLoanDashboardData?.collection?.total,
        ),
      }
    },
    {
      title: activeTab === "loan" ? "Loan Pending Collection" : "Group Loan Pending Collection",
      stats: {
        TODAY: formatINR(
          activeTab === "loan"
            ? pendingCollectionData.today
            : groupLoanDashboardData?.pendingCollection?.today,
        ),
        ...(activeTab === "loan" && {
          WEEKLY: formatINR(pendingCollectionData.weekly),
          MONTHLY: formatINR(pendingCollectionData.monthly),
          YEARLY: formatINR(pendingCollectionData.yearly),
        }),
        TOTAL: formatINR(
          activeTab === "loan"
            ? pendingCollectionData.total
            : groupLoanDashboardData?.pendingCollection?.total,
        ),
      }
    },
    {
      title: activeTab === "loan" ? "Loan Disbursement" : "Group Loan Disbursement",
      stats: {
        TODAY: formatINR(
          activeTab === "loan"
            ? disbursementData?.disbursed?.today
            : groupLoanDashboardData?.disbursement?.today,
        ),
        ...(activeTab === "loan" && {
          WEEKLY: formatINR(disbursementData?.disbursed?.weekly),
          MONTHLY: formatINR(disbursementData?.disbursed?.monthly),
          YEARLY: formatINR(disbursementData?.disbursed?.yearly),
        }),
        TOTAL: formatINR(
          activeTab === "loan"
            ? disbursementData?.disbursed?.total
            : groupLoanDashboardData?.disbursement?.total,
        ),
      }
    },
    {
      title: activeTab === "loan" ? "Loan Pending Disbursement" : "Group Loan Pending Disbursement",
      stats: {
        ...(activeTab === "loan" && {
          TODAY: formatINR(disbursementData?.pending?.today),
          WEEKLY: formatINR(disbursementData?.pending?.weekly),
          MONTHLY: formatINR(disbursementData?.pending?.monthly),
          YEARLY: formatINR(disbursementData?.pending?.yearly),
        }),
        TOTAL: formatINR(
          activeTab === "loan"
            ? disbursementData?.pending?.total
            : groupLoanDashboardData?.pendingDisbursement?.total,
        ),
      }
    },
  ];

  /* ---------------- JSX ---------------- */
  return (
    <div className="bd-dashboard-root">
      <div className="bd-dashboard-header">
        <div className="running-text">
          <h1 className="gradient-text-white">
            Welcome, {company?.name || "Company Name"}, Branch({profile?.branchName || "N/A"})
          </h1>
        </div>
      </div>

      <div className="db-kpis-quick-grid">
        {/* KPIs */}
        <div className="bd-kpi-card">
          <div className="bd-kpi-list">
            {kpiData.map((kpi, index) => (
              <div className="bd-kpi-row" key={index}>
                <div className={`bd-kpi-icon bd-kpi-${index + 1}`}>
                  {kpi.icon}
                </div>
                <div className="bd-kpi-text">
                  <span className="bd-kpi-value">{kpi.value}</span>
                  <span className="bd-kpi-label">{kpi.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Side Section: Balance + Quick Access */}
        <div className="bd-side-controls">
          <div className="bd-quick-card">
            <h2 className="bd-card-title">Balance Overview</h2>
            <div className="db-balance-grids">
              <div className="db-balance-data-card">
                <h3>Opening Balance</h3>
                {/* <p>Cash Balance: <span>{formatINR(openingBalance?.cashBalance)}</span></p> */}
                {/* <p>Total Balance: <span>{formatINR(openingBalance?.totalBalance)}</span></p> */}
                <span className="closing-val">{formatINR(openingBalance?.cashBalance)}</span>
              </div>
              <div className="db-balance-data-card highlight">
                <h3>Closing Balance</h3>
                <span className="closing-val">{formatINR(closingBalance)}</span>
              </div>
            </div>
          </div>

          <div className="bd-quick-card mt-15">
            <h2 className="bd-card-title">Quick Access</h2>
            <div className="bd-quick-grid">
              {quickAccess.map((item, index) => (
                <Link
                  to={item.link}
                  key={index}
                  className={`bd-quick-item bd-quick-${index + 1}`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* COLLECTION OVERVIEW */}
      <section className="bd-collection-section">
        <div className="bd-loan-parent-tabs">
          <button
            className={`bd-parent-tab-btn ${activeTab === "loan" ? "active" : ""}`}
            onClick={() => setActiveTab("loan")}
          >
            Loan
          </button>
          <button
            className={`bd-parent-tab-btn ${activeTab === "group_loan" ? "active" : ""}`}
            onClick={() => setActiveTab("group_loan")}
          >
            Group Loan
          </button>
        </div>

        <div className="bd-overview-grid">
          {overviewData.map((ov, index) => (
            <div className={`bd-overview-card color-${index}`} key={index}>
              <div className="bd-overview-header">
                <h3 className="bd-overview-title">{ov.title}</h3>
              </div>

              <div className="bd-overview-stats">
                {Object.entries(ov.stats).map(([label, value]) => (
                  <div
                    key={label}
                    className={`bd-stat-row ${label === "TOTAL" ? "bd-stat-total" : ""}`}
                  >
                    <span>{label}</span>
                    <span className="bd-stat-value">{value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}